import { RecordUtils } from "@rsm-hcd/javascript-core";
import { Record } from "immutable";
import { HubspotForm } from "models/interfaces/hubspot-form";
import HubspotFormFieldRecord from "models/view-models/hubspot-form-field-record";
import { CollectionUtils } from "utilities/collection-utils";

const defaultValues: HubspotForm = {
    name: "",
    portalId: 0,
    fields: [],
};

export default class HubspotFormRecord
    extends Record(defaultValues)
    implements HubspotForm
{
    // -----------------------------------------------------------------------------------------
    // #region Constructor
    // -----------------------------------------------------------------------------------------

    constructor(params?: HubspotForm) {
        if (params == null) params = Object.assign({}, defaultValues);
        if (CollectionUtils.hasValues(params.fields)) {
            params.fields = params.fields.map((r) =>
                RecordUtils.ensureRecord(r, HubspotFormFieldRecord)
            );
        }

        super(params);
    }

    // #endregion Constructor
}
